import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { parserFichierImport, telechargerModele } from '../services/excelService';
import api from '../services/api';

const C = {
  primary: '#2E7D32', primaryDark: '#1B5E20',
  border: '#E0E0E0', light: '#F4F6F9',
  green100: '#E8F5E9', textDark: '#212121', textMid: '#616161', textLight: '#9E9E9E',
};

const S = {
  page: { minHeight: '100vh', background: C.light },
  topbar: { height: 52, background: '#fff', borderBottom: `1px solid ${C.border}`,
    display: 'flex', alignItems: 'center', justifyContent: 'space-between',
    padding: '0 24px', position: 'sticky', top: 0, zIndex: 100, flexShrink: 0 },
  breadcrumb: { fontSize: 13, color: C.textLight, display: 'flex', alignItems: 'center', gap: 6 },
  breadcrumbActive: { color: C.textDark, fontWeight: 600 },
  container: { maxWidth: 900, margin: '20px auto', padding: '0 20px', paddingBottom: 40 },
  carte: { background: '#fff', borderRadius: 12, border: `0.5px solid ${C.border}`,
    boxShadow: '0 1px 3px rgba(0,0,0,0.06)', marginBottom: 12, overflow: 'hidden' },
  sectionHeader: { background: C.primary, color: '#fff', padding: '10px 16px', fontSize: 13, fontWeight: 700 },
  carteBody: { padding: '14px 16px' },
  btnPrimary: { background: C.primary, color: 'white', border: 'none', padding: '8px 18px',
    borderRadius: 8, cursor: 'pointer', fontSize: 13, fontWeight: 600 },
  btnOrange: { background: '#E65100', color: 'white', border: 'none', padding: '8px 18px',
    borderRadius: 8, cursor: 'pointer', fontSize: 13, fontWeight: 600 },
  inputFile: { display: 'none' },
  labelChoisir: { display: 'inline-flex', alignItems: 'center', gap: 8,
    border: `2px dashed ${C.primary}`, borderRadius: 8, padding: '12px 24px',
    cursor: 'pointer', fontSize: 13, color: C.primary, fontWeight: 600,
    background: '#F1F8F2', margin: '4px 0' },
  th: { background: '#F8F9FA', color: C.textMid, padding: '7px 10px', textAlign: 'left',
    fontSize: 11, fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.4px',
    borderBottom: `1px solid ${C.border}` },
  td: { padding: '7px 10px', borderBottom: `1px solid #F0F2F4`, fontSize: 12, color: C.textDark },
  resultatBox: { padding: '14px 16px', borderRadius: 8, background: C.green100,
    border: '1px solid #A5D6A7', marginTop: 14 },
  detailItem: { fontSize: 12, padding: '3px 0', borderBottom: `1px solid ${C.border}`, color: C.textMid },
};

export default function ImportPage() {
  const navigate = useNavigate();
  const [fichier, setFichier] = useState(null);
  const [apercu, setApercu] = useState([]);
  const [resultat, setResultat] = useState(null);
  const [chargement, setChargement] = useState(false);

  const chargerFichier = async (e) => {
    const f = e.target.files[0];
    if (!f) return;
    setFichier(f);
    try {
      const lignes = await parserFichierImport(f);
      setApercu(lignes.slice(0, 5));
    } catch (err) {
      alert('Fichier invalide !');
    }
  };

  const importer = async () => {
    if (!fichier) return;
    setChargement(true);
    try {
      const lignes = await parserFichierImport(fichier);
      const r = await api.post('/import', { lignes });
      setResultat(r.data);
    } catch (err) {
      alert(err.response?.data?.message || 'Erreur import.');
    } finally {
      setChargement(false);
    }
  };

  return (
    <div style={S.page}>
      {/* Topbar */}
      <div style={S.topbar}>
        <div style={S.breadcrumb}>
          <span>Production</span>
          <span style={{ color: C.border }}>›</span>
          <span style={S.breadcrumbActive}>Import de données</span>
        </div>
        <button style={{ background: 'transparent', border: 'none', color: C.textMid, fontSize: 13, cursor: 'pointer' }}
          onClick={() => navigate('/saisies')}>← Retour à la liste</button>
      </div>

      <div style={S.container}>
        {/* Étape 1 */}
        <div style={S.carte}>
          <div style={S.sectionHeader}>📋 Étape 1 — Télécharger le modèle</div>
          <div style={S.carteBody}>
            <p style={{ color: C.textMid, marginBottom: 12, fontSize: 13 }}>
              Téléchargez le fichier modèle Excel, remplissez-le avec vos données, puis importez-le.
            </p>
            <button style={S.btnPrimary} onClick={telechargerModele}>
              📥 Télécharger le modèle Excel
            </button>
            <div style={{ marginTop: 12, padding: '10px 14px', background: '#FFF8E1',
              borderRadius: 7, fontSize: 12, color: '#E65100', border: '1px solid #FFCC80' }}>
              <strong>⚠️ Codes abattoirs :</strong> ABT-DKR, ABT-THS, ABT-KLK, ABT-SGL, ABT-ZGC, ABT-TBA, ABT-DBL, ABT-LGA
            </div>
          </div>
        </div>

        {/* Étape 2 */}
        <div style={S.carte}>
          <div style={S.sectionHeader}>📂 Étape 2 — Choisir le fichier</div>
          <div style={S.carteBody}>
            <div>
              <input
                id="file-import-input"
                type="file"
                accept=".xlsx,.xls,.csv"
                onChange={chargerFichier}
                style={S.inputFile}
              />
              <label htmlFor="file-import-input" style={S.labelChoisir}>
                📂 {fichier ? fichier.name : 'Choisir un fichier Excel'}
              </label>
            </div>
            {apercu.length > 0 && (
              <div>
                <div style={{ fontWeight: 700, color: C.primaryDark, marginBottom: 8, fontSize: 13 }}>
                  Aperçu ({apercu.length} premières lignes) :
                </div>
                <div style={{ overflowX: 'auto' }}>
                  <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                    <thead>
                      <tr>
                        {Object.keys(apercu[0]).map(k => <th key={k} style={S.th}>{k}</th>)}
                      </tr>
                    </thead>
                    <tbody>
                      {apercu.map((l, i) => (
                        <tr key={i} style={{ background: i % 2 === 0 ? '#fff' : '#FAFAFA' }}>
                          {Object.values(l).map((v, j) => (
                            <td key={j} style={S.td}>
                              {v instanceof Date ? v.toISOString().split('T')[0] : String(v ?? '')}
                            </td>
                          ))}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            )}
          </div>
        </div>

        {/* Étape 3 */}
        {fichier && (
          <div style={S.carte}>
            <div style={S.sectionHeader}>🚀 Étape 3 — Lancer l'import</div>
            <div style={S.carteBody}>
              <button style={S.btnOrange} onClick={importer} disabled={chargement}>
                {chargement ? '⏳ Import en cours...' : "🚀 LANCER L'IMPORT"}
              </button>

              {resultat && (
                <div style={S.resultatBox}>
                  <div style={{ fontWeight: 700, fontSize: 14, marginBottom: 10, color: C.primaryDark }}>
                    ✅ {resultat.message}
                  </div>
                  <div style={{ maxHeight: 200, overflowY: 'auto' }}>
                    {resultat.resultats.details.map((d, i) => (
                      <div key={i} style={S.detailItem}>{d}</div>
                    ))}
                  </div>
                  <button style={{ ...S.btnPrimary, marginTop: 14 }} onClick={() => navigate('/saisies')}>
                    ← Retour aux saisies
                  </button>
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
